/// <amd-module name="SuiteCommerce.GiftCertificate.Common.DependencyProvider"/>
define("SuiteCommerce.GiftCertificate.Common.DependencyProvider", ["require", "exports", "underscore", "Utils", "Backbone.CachedCollection", "Backbone.CachedModel"], function (require, exports, _, UtilsModuleSC, BackboneCCollection, BackboneCModel) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.UtilsModule = exports.BackboneCachedCollection = exports.BackboneCachedModel = void 0;
    exports.BackboneCachedModel = getDependency(BackboneCModel);
    exports.BackboneCachedCollection = getDependency(BackboneCCollection);
    exports.UtilsModule = getDependency(UtilsModuleSC);
    function getDependency(module) {
        if (isTranspiledModule(module)) {
            return module[Object.keys(module)[0]];
        }
        return module;
    }
    function isTranspiledModule(module) {
        var moduleKeys = Object.keys(module);
        return !_.isFunction(module) && moduleKeys.length === 1;
    }
});
